export const AUTH_USER_LS_KEY = 'lmsUser'
